export const ENVIRONMENT = 'ENVIRONMENT';
export const ENVIRONMENTSEARCH = 'ENVIRONMENTSEARCH';
export const ENVIRONMENTECREPORT = 'ENVIRONMENTECREPORT';